
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admin/emails",
      function () {
        return require("private-next-pages/admin/emails.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/admin/emails"])
      });
    }
  